import { render, staticRenderFns } from "./RemitterCreditComponent.vue?vue&type=template&id=543152f6"
import script from "./RemitterCreditComponent.vue?vue&type=script&lang=js"
export * from "./RemitterCreditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports